import { Box } from '@mui/material';
import { useTheme } from '@mui/material';

interface FormContainerProps {
  children: React.ReactNode;
}

export function FormContainer({ children }: FormContainerProps) {
  const theme = useTheme();
  
  return (
    <Box sx={{ 
      background: theme.palette.background.paper, 
      borderRadius: 3, 
      p: 4, 
      maxWidth: 800, 
      margin: '32px auto', 
      boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)' 
    }}>
      {children}
    </Box>
  );
} 